import React from 'react'

const themes = [
  { id: 'light', name: 'Светлая', color: '#7C3AED', icon: '' },
  { id: 'dark', name: 'Тёмная', color: '#1A1A2E', icon: '' },
]

export default function AppearanceSettings({ activeTheme, handleThemeChange }) {
  return (
    <div className="settings-section animate-fade-in">
      <h3 className="settings-section-title">Цветовая тема</h3>
      <div className="settings-themes">
        {themes.map((theme) => (
          <button
            key={theme.id}
            className={`settings-theme-card ${activeTheme === theme.id ? 'active' : ''}`}
            onClick={(e) => handleThemeChange(theme.id, e)}
          >
            <div
              className="settings-theme-preview"
              style={{ background: theme.color }}
            >
              {theme.icon}
            </div>
            <span className="settings-theme-name">{theme.name}</span>
            {activeTheme === theme.id && (
              <span className="settings-theme-check"></span>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
